import { AxiosError } from 'axios';
import { RawServicesError, RawSfError, ToastTypes, WCEvents, shouldOverrideShowApiError } from '@hfc/ui-core';
import { useAppStore } from '@/shared/infrastructure/composition/useAppStore';

const { emitToastEvent } = WCEvents();

interface HandleApiError {
  handleServicesApiError: (error: AxiosError<RawServicesError>, showApiError?: boolean, genericMessage?: string) => void;
  handleSfApiError: (error: AxiosError<RawSfError> | AxiosError<RawServicesError>, showApiError?: boolean, genericMessage?: string) => void;
}

export function useHandleApiError (): HandleApiError {
  const { appStore } = useAppStore();

  const handleServicesApiError = (error: AxiosError<RawServicesError>, showApiError: boolean = false, genericMessage: string = 'There was an error.'):void => {
    const shouldShowApiError = showApiError || shouldOverrideShowApiError();

    if (shouldShowApiError && error?.response?.data) {
      Object.values(error.response.data).forEach((value) => {
        if (typeof value === 'string') {
          appStore.addToast({
            message: value,
            type: ToastTypes.DANGER
          });
        }
      });

      return;
    }

    emitToastEvent(ToastTypes.DANGER, genericMessage);
    appStore.addToast({
      message: genericMessage,
      type: ToastTypes.DANGER
    });
  };

  const handleSfApiError = (error: AxiosError<RawSfError> | AxiosError<RawServicesError>, showApiError: boolean = false, genericMessage: string = 'There was an error.'):void => {
    if (!error?.response?.data || !('error' in error.response.data) || typeof error.response.data.error !== 'string') {
      return handleServicesApiError(error as AxiosError<RawServicesError>, showApiError, genericMessage);
    }

    const shouldShowApiError = showApiError || shouldOverrideShowApiError();

    emitToastEvent(ToastTypes.DANGER, shouldShowApiError && error?.response?.data.error ? error.response.data.error : genericMessage);
    appStore.addToast({
      message: shouldShowApiError && error?.response?.data.error ? error.response.data.error : genericMessage,
      type: ToastTypes.DANGER
    });
  };

  return {
    handleServicesApiError,
    handleSfApiError
  };
}
